<template>
  <div class="flex w-full flex-col">
    <div
      ref="mainMenuWrap"
      class="relative z-10 bg-gray-lighten3 text-slate shadow-outerMenu md:shadow-none"
      :class="[
        headerBgColor,
        headerTextColor,
        { 'z-50': isMenuOpen || isMobileMenuOpen },
      ]"
    >
      <div class="container flex justify-between py-4">
        <div class="mr-12 w-[110px] flex-shrink-0 md:w-[132px]">
          <UiLink to="/" aria-label="Go to home page">
            <AppLogo />
          </UiLink>
        </div>

        <HeaderMainMenu
          :menu="menuMain"
          :menu-wrapper-ref="mainMenuWrap"
          :is-open="isMenuOpen"
          :dark="dark"
          class="hidden md:flex"
          @toggle-menu="toggleMenu"
        />

        <div class="ml-auto flex" :class="{ 'text-slate': isMenuOpen }">
          <button
            v-if="!isJoinuApp"
            aria-label="Open search"
            class="self-center md:mr-9"
            @click="openSearch"
          >
            <UiIcon :icon="'search'"></UiIcon>
          </button>

          <NuxtLink
            v-if="false"
            :to="'/'"
            class="mr-9 self-center md:inline-flex"
          >
            <UiIcon :icon="'user'"></UiIcon>
          </NuxtLink>

          <UiButton
            v-if="isJoinuApp"
            :to="$t('joinu_header_button_link')"
            size="sm"
            class="mr-2 hidden self-center md:inline-flex"
            variant="joinu"
          >
            {{ $t('joinu_header_button_text') }}
          </UiButton>
          <UiButton
            to="#consult-form"
            size="sm"
            class="hidden self-center md:inline-flex"
          >
            {{ $t('contact_sales') }}
          </UiButton>

          <button
            class="ml-9 self-center text-blue md:hidden"
            aria-label="Open mobile menu"
            @click="toggleMobileMenu"
          >
            <UiIcon :icon="'menubar'"></UiIcon>
          </button>

          <div class="overflow-auto md:hidden">
            <HeaderMainMenuMobile
              :value="isMobileMenuOpen"
              :menu="menuMain"
              @toggle-menu="toggleMobileMenu"
            />
          </div>
        </div>
      </div>
    </div>

    <UiModal
      v-model="isOpenSearch"
      background="gray"
      width="1118px"
      :close-button="isDesktop ? 'outside' : ''"
    >
      <template #closeButton>
        {{ $t('close') }}
      </template>

      <AppSearch @close="closeSearch" />
    </UiModal>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import HeaderMainMenu from '@/domains/menus/components/HeaderMainMenu.vue';
import HeaderMainMenuMobile from '@/domains/menus/components/HeaderMainMenuMobile.vue';
import { useOpenClose, useBreakpoint, useBodyScrollLock } from '~/composables';

interface Props {
  menuTop?: any[];
  menuMain?: any[];
  dark?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  menuTop: () => [],
  menuMain: () => [],
  dark: false,
});
const { joinuApp: isJoinuApp } = useRuntimeConfig().public.frontkit;
const { isBiggerThanBreakpoint: isDesktop } = useBreakpoint('md');
const mainMenuWrap = ref<HTMLElement>();
const {
  isOpen: isOpenSearch,
  open: openSearch,
  close: closeSearch,
} = useOpenClose();
const isMenuOpen = ref(false);
const isMobileMenuOpen = ref(false);

useBodyScrollLock(isMobileMenuOpen);

const headerBgColor = computed(() => {
  if (isMenuOpen.value) return 'md:bg-gray-lighten3';
  if (props.dark) return 'md:bg-gray-lighten3';

  return 'md:bg-transparent';
});

const headerTextColor = computed(() => {
  if (isMenuOpen.value) return 'md:text-[#494949]';
  if (props.dark) return 'md:text-slate';

  return 'md:text-white';
});

const toggleMenu = (value: boolean) => {
  isMenuOpen.value = value;
};

const toggleMobileMenu = () => {
  isMobileMenuOpen.value = !isMobileMenuOpen.value;
};
</script>
